import React from 'react';

import ReportPartsNavbarView from './report-part-navbar.view';

interface ReportPartsNavbarViewProps {
  activeButton: string;
  handleButtonClick: any;
  reportDetailData: any;
  buttonData: any;
}

const ReportPartsNavbar = ({ buttonData, activeButton, handleButtonClick }: ReportPartsNavbarViewProps) => {
  const filteredData = buttonData.filter((value: { value: any }, index: any, self: any[]) => index === self.findIndex((item) => item.value === value.value));
  const props = {
    filteredData,
    activeButton,
    handleButtonClick,
  };

  // console.group('report-part-navbar');
  // console.log('===> buttonData :: ', buttonData);
  // console.log('===> filteredData :: ', filteredData);
  // console.groupEnd();

  return <ReportPartsNavbarView {...props} />;
};

export default ReportPartsNavbar;
